import { useEffect, useState } from "react";
import config from "../config";
import { IoIosAdd } from "react-icons/io";
import { AiOutlineDelete } from "react-icons/ai";

export default function Upload() {
  const initialFormData = {
    MediaTypeId: "",
    title: "",
  };

  const [contents, setContents] = useState([]);

  const [uploadData, setUploadData] = useState(initialFormData);
  const [selectedFile, setSelectedFile] = useState(null);

  const [recordToDelete, setRecordToDelete] = useState(null); // State to track the record to delete

  const [responseMessage, setResponseMessage] = useState("");
  const [showResponse, setShowResponse] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  const [mediaType, setMediaType] = useState([]);

  const [uploadProgress, setUploadProgress] = useState(0);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUploadData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const clearForm = () => {
    setUploadData(initialFormData);
    document.getElementById("FileUrl").value = null;
    document.getElementById("MediaTypeId").value = "Select a Media type";
  };

  // fetching media for media list
  const fetchMedia = async () => {
    if (!hasMore) return;

    setIsLoading(true);

    try {
      const response = await fetch(
        `${config.apiUrl}lazyLoad.php?option=3&subcategory=0&page=${page}`
      );
      const fetchUploadData = await response.json();

      // Extract the list of contents from the API response
      const newContents = fetchUploadData.map((item) => ({
        id: item.mediaId,
        title: item.title,
        MediaType: item.MediaType,
        MediaTypeId: item.MediaTypeId,
        PostDate: item.PostDate,
        url: item.url,
      }));

      setContents([...contents, ...newContents]);
      setPage(page + 1);
      setHasMore(newContents.length > 0);
    } catch (error) {
      console.log("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadMore = () => {
    fetchMedia();
  };

  useEffect(() => {
    fetchMedia(); // Initial data fetch
  }, []);

  // TODO: change the bellow code from scroll to click
  useEffect(() => {
    window.addEventListener("scroll", loadMore);

    return () => {
      window.removeEventListener("scroll", loadMore);
    };
  }, [page]);

  useEffect(() => {
    fetchMediaType();
  }, []);

  // fetching media type for form
  const fetchMediaType = async () => {
    try {
      const response = await fetch(
        `${config.apiUrl}contentapi.php?option=1&type=10&subcategory=0`
      );
      const mediaTypeData = await response.json();
      setMediaType(mediaTypeData);
    } catch (error) {
      setErrorMessage(error);
      setShowError(true);

      // Hide the response message after 5 seconds
      setTimeout(() => {
        setShowError(false);
        setErrorMessage("");
      }, 5000);
    }
  };

  const mediaTypeSelect = mediaType.map((mediaType) => (
    <option key={mediaType.id} value={mediaType.id}>
      {mediaType.MediaType}
    </option>
  ));

  //handle upload and save file
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("file", selectedFile);

    const xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      `${config.uploadUrl}sup/UploadHandler.ashx?mediaTypeId=${uploadData.MediaTypeId}`,
      true
    ); // Upload to a separate endpoint

    // Show progress for the file upload
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        setUploadProgress(percentComplete);
      }
    };

    // Handle response after the file upload
    xhr.onload = () => {
      if (xhr.status === 200) {
        // Use the new file name for database saving
        const uploadedFiles = JSON.parse(xhr.responseText);

        // Now, send the fileName, title, and mediaTypeId to uploadapi.php for database saving
        const postData = new FormData();
        postData.append("MediaTypeId", uploadData.MediaTypeId);
        postData.append("title", uploadData.title);
        postData.append("thumbnail", uploadedFiles.thumbnail); // return from C#
        postData.append("fileName", uploadedFiles.large); // return from C#

        const xhr2 = new XMLHttpRequest();
        xhr2.open("POST", `${config.apiUrl}uploadapi.php?type=5`, true);

        xhr2.onload = () => {
          if (xhr2.status === 200) {
            const data = JSON.parse(xhr2.responseText);

            setResponseMessage(data.message);
            setShowResponse(true);

            const newMedia = {
              title: uploadData.title,
              MediaType: mediaType.find(
                (type) => type.id === uploadData.MediaTypeId
              )?.mediaType,
              PostDate: data.data.PostDate,
              url: data.data.url, // Assuming the response contains the URL
              id: data.data.id,
            };

            setContents((prev) => [newMedia, ...prev]);

            clearForm();
            setUploadProgress(0);

            setTimeout(() => {
              setShowResponse(false);
              setResponseMessage("");
            }, 5000);
          } else {
            const data = JSON.parse(xhr2.responseText);
            setErrorMessage(data.message);
            setShowError(true);

            setTimeout(() => {
              setErrorMessage("");
              setShowError(false);
            }, 5000);
          }
        };

        xhr2.onerror = () => {
          setErrorMessage("An error occurred while saving the data.");
          setShowError(true);

          setTimeout(() => {
            setErrorMessage("");
            setShowError(false);
          }, 5000);
        };

        xhr2.send(postData);
      } else {
        setErrorMessage("File upload failed.");
        setShowError(true);

        setTimeout(() => {
          setErrorMessage("");
          setShowError(false);
        }, 5000);
      }
    };

    xhr.onerror = () => {
      setErrorMessage("An error occurred during the file upload.");
      setShowError(true);

      setTimeout(() => {
        setErrorMessage("");
        setShowError(false);
      }, 5000);
    };

    xhr.send(formData);
  };

  // Function to handle the deletion of a record
  const handleDelete = (record) => {
    setRecordToDelete(record); // Set the record to be deleted
  };

  // Function to confirm and delete the record
  const confirmDelete = async () => {
    try {
      // Make an API call to delete the record
      const response = await fetch(`${config.apiUrl}deleterecord.php?type=2`, {
        method: "POST",
        body: JSON.stringify({ id: recordToDelete.id }), // Assuming your record has an 'id' property
      });

      if (response.ok) {
        const updatedContents = contents.filter(
          (record) => record !== recordToDelete
        );
        setContents(updatedContents);
        setRecordToDelete(null); // Reset the record to be deleted
      } else {
        // Handle the case where the deletion fails
        console.error("Deletion failed");
      }
    } catch (error) {
      console.error("Error deleting record:", error);
    }
  };

  const allMedias = contents.map((file, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      <td>{file.title}</td>
      <td>{file.MediaType}</td>
      <td>{file.PostDate}</td>
      <td>
        <a
          href={`${config.uploadUrl}${file.url}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {config.uploadUrl}
          {file.url}
        </a>
      </td>
      <td>
        {/* Delete Button and modal */}
        <button
          type="button"
          className="btn btn-sm btn-danger rounded"
          data-bs-toggle="modal"
          data-bs-target="#fileModal"
          onClick={() => handleDelete(file)}
        >
          <AiOutlineDelete />
        </button>
        <div
          className="modal fade"
          id="fileModal"
          tabIndex="-1"
          aria-labelledby="fileModalLabel"
          aria-hidden="true"
          dir="ltr"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="fileModalLabel">
                  حذف ریکارد
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body" dir="rtl">
                آیا مطمئن هستید که حذف شود؟
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  لغو
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={confirmDelete}
                  data-bs-dismiss="modal"
                >
                  حذف شود
                </button>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  ));

  return (
    <>
      <nav className="navbar bg-body-tertiary">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">Upload</span>
        </div>
      </nav>
      <div dir="ltr" className="p-3" style={{ fontSize: "smaller" }}>
        {/* new record form */}
        <div className="p-3">
          <p className="d-inline-flex gap-1">
            <button
              className="btn btn-success"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              ریکارد جدید <IoIosAdd />
            </button>
          </p>
          <div className="collapse" id="collapseExample">
            <div className="card card-body" dir="rtl">
              <form onSubmit={handleSubmit}>
                <div className="form-group row g-3">
                  <div className="col-lg-4">
                    <label htmlFor="title" className="form-label">
                      Title
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      name="title"
                      value={uploadData.title}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-lg-4">
                    <label htmlFor="MediaTypeId" className="form-label">
                      Media type
                    </label>
                    <select
                      id="MediaTypeId"
                      required
                      name="MediaTypeId"
                      className="form-select"
                      value={uploadData.MediaTypeId}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select a Media type
                      </option>
                      {mediaTypeSelect}
                    </select>
                  </div>
                  <div className="col-lg-3">
                    <label htmlFor="FileUrl" className="form-label">
                      File
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="FileUrl"
                      name="FileUrl"
                      onChange={handleFileChange}
                      required
                    />
                  </div>
                </div>
                {showResponse && (
                  <div className="alert alert-success my-2">
                    {responseMessage}
                  </div>
                )}
                {showError && (
                  <div className="alert alert-danger my-2">{errorMessage}</div>
                )}
                <div className="d-flex justify-content-end gap-2 my-4">
                  <button type="submit" className="btn btn-primary">
                    Upload
                  </button>
                </div>
                {uploadProgress > 0 && (
                  <div className="progress my-2">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${uploadProgress}%` }}
                      aria-valuenow={uploadProgress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {Math.round(uploadProgress)}%
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
        {/* media list */}
        <div className="bg-body rounded">
          <nav className="navbar bg-info rounded-top" dir="rtl">
            <div className="container-fluid">
              <span className="navbar-brand mb-0 h1">فایل ها</span>
            </div>
          </nav>
          <div>
            <div className="p-3 ms-auto form-group col-lg-4 inline" dir="rtl">
              <input
                type="search"
                placeholder="جستجو..."
                className="form-control"
              />
            </div>
          </div>
          <div className="max-container-width py-3 text-body">
            <table className="table" dir="rtl">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Title</th>
                  <th scope="col">Media type</th>
                  <th scope="col">Post Date</th>
                  <th scope="col">Url</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>{allMedias}</tbody>
            </table>
            {hasMore && !isLoading && (
              <div className="text-center mt-5">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary rounded"
                  id="loadmore"
                  onClick={() => loadMore()}
                >
                  مطالب بیشتر
                </button>
              </div>
            )}

            {!hasMore && !isLoading && (
              <div className="mt-5 text-center">
                <small className="p-2 bg-secondary text-light rounded">
                  پایان مطالب
                </small>
              </div>
            )}

            {isLoading && (
              <div className="d-flex justify-content-center">
                <div
                  className="spinner-border primary-text-blue"
                  dir="ltr"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
